document.addEventListener('DOMContentLoaded', () => {

    // Control keep shopping/go to checkout modal and overlay toggle.
    document.querySelector('.checkout-modal-overlay .button').addEventListener('click', doRemoveOverlay);

    // Attempt to remove overlay by escape key.
    document.onkeydown = (function (event) {
        if (event.code === 'Escape') {
            doRemoveOverlay();
        }
    });

    // Attempt to remove overlay from event, checking for matching className first.
    function removeOverlayCheck(event) {
        let elementClass = event.target.class;
        if (elementClass.includes('checkout-modal-overlay') || elementClass.includes('button')) {
            doRemoveOverlay();
        }
    }

    // Hide the overlay.
    function doRemoveOverlay() {
        document.querySelector('.checkout-modal-overlay').classList.remove('is-visible');
    }

    // Show the overlay
    if (window.location.hash === '#added_product') {
        // On cart content change, show overlay.
        document.querySelector('.checkout-modal-overlay').classList.add('is-visible');
    }
});
